document.addEventListener("alpine:init", () => {
    Alpine.data("contactForm", () => ({
        selectfields: null,
        success: false,
        form: null,
        confirmationPage: null,
        downloadLink: null,
        init() {
            this.form = this.$el.querySelector("form.wpcf7-form");

            if (this.form) {
                this.confirmationPage = this.$el.dataset.confirmationPage;
                this.form.addEventListener("wpcf7mailsent", (event) => {
                    this.fetchConfirmation();
                });

                this.downloadLink = this.$el.dataset.downloadLink;

                this.selectfields = this.$el.querySelectorAll("select");

                if (this.selectfields) {
                    pegasus.selectField(this.selectfields, {
                        openOnHover: false,
                        itemsToShow: 5,
                        firstItemDisabled: true,
                        classNames: {
                            outerWrapper: "",
                            selector:
                                "Form__Selector -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                            selectorOpen: "-open",
                            selectionList:
                                "Form__Selector-list w-full rounded-b-md -open",
                            listItem:
                                "select-none relative transition duration-300 py-4 px-6",
                            listItemFocus: "bg-brand-cloud",
                        },
                    });
                }
            }
        },

        fetchConfirmation() {
            const mainContainer = this.$el.querySelector(".main-container");
            fetch(this.confirmationPage)
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser(),
                        doc = parser.parseFromString(html, "text/html");

                    const replace = doc.querySelector("main > article");
                    mainContainer.innerHTML = replace.innerHTML;
                    this.success = true;

                    if (this.downloadLink) {
                        window.open(this.downloadLink);
                    }
                });
        },
    }));
});
